export default "__VITE_ASSET__Dtt1m4Ii__"